import { Component, Input, OnInit } from '@angular/core'
import { QueryLogic } from '@cyborg-monorepo/hunter/common'

@Component({
  standalone: false,
  selector: 'cyborg-query-logic',
  templateUrl: './query-logic.component.html',
  styleUrls: ['./query-logic.component.scss'],
})
export class QueryLogicComponent implements OnInit {
  @Input() public queryLogic: QueryLogic
  public queryLogicCondition: string
  public queryLogicData: Array<{
    field: string
    selection: string
    value: string
  }>

  public ngOnInit(): void {
    this.populateHumanReadableTable()
  }

  public populateHumanReadableTable(): void {
    const queryLogic: QueryLogic = this.queryLogic
    if (queryLogic.table) {
      this.queryLogicCondition = this.queryLogic.condition
      this.queryLogicData = queryLogic.table
        .map((item) => {
          const queryLogicDataArray: Array<{
            selection: string
            field: string
            value: string
          }> = []
          for (const [index, val] of item.value.entries()) {
            if (index === 0) {
              if (!item.grouped) {
                if (item.value.length > 1) {
                  queryLogicDataArray.push({
                    selection: item.selection + ' (ANY)',
                    field: item.field,
                    value: val,
                  })
                } else {
                  queryLogicDataArray.push({
                    selection: item.selection,
                    field: item.field,
                    value: val,
                  })
                }
              } else {
                if (item.value.length > 1) {
                  queryLogicDataArray.push({
                    selection: item.selection + ' (ALL)',
                    field: item.field,
                    value: val,
                  })
                } else {
                  queryLogicDataArray.push({
                    selection: item.selection,
                    field: item.field,
                    value: val,
                  })
                }
              }
            } else {
              queryLogicDataArray.push({
                selection: '',
                field: item.field,
                value: val,
              })
            }
          }
          return queryLogicDataArray
        })
        .flat()
    }
  }
}
